<template>
  <v-flex>
    <div class="d-flex align-center">
      <h1>{{ name }}</h1>
    </div>
    <v-card>
      <v-card-title>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          v-model="search"
          class="mr-3"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn fab dark color="indigo" slot="activator" @click="updateSku">
            <v-icon dark>sync</v-icon>
          </v-btn>
          <span>Synchronize with external API, do this when some SKU was added</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="skuList"
        :search="searchTrimmed"
        class="elevation-1"
        hide-actions
        v-if="!loading"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.count }}</td>
        </template>
      </v-data-table>
    </v-card>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'
import { SKU_LIST, UPDATE_SKU } from '../../store/actions/sku'

export default {
  data: () => ({
    name: 'SKU List',
    loading: true,
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'Name', value: 'name' },
      { text: 'Code', value: 'code' },
      { text: 'App Blocks', value: 'count' }
    ],
    search: ''
  }),
  computed: {
    ...mapGetters([
      'skuList'
    ]),
    searchTrimmed: function () {
      return this.search.trim()
    }
  },
  methods: {
    updateSku: async function () {
      this.loading = true
      console.log('update')
      await this.$store.dispatch(UPDATE_SKU)
      this.loading = false
    }
  },
  mounted: async function () {
    this.loading = true
    await this.$store.dispatch(SKU_LIST)
    this.loading = false
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sku/Index.vue